import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import NavButton1 from './NavButton1';
import NavButton2 from './NavButton2';

import logo from '../../assets/img/logo/logo2.png'

const Nav = ({ actual, onNavButtonClick }) => {
    
    const navigate = useNavigate();
    const [menu, setMenu] = useState('not-visible');
    const [menuAnimation, setMenuAnimation] = useState('move-nav');
    const [menuAnimation2, setMenuAnimation2] = useState('fade-nav');

    const handleButtonClick = () => {
        if (onNavButtonClick) {
            onNavButtonClick();
        }
    };

    const handleMenuButtonClick = async (redirect) => {
        if (onNavButtonClick) {
            toggleMenu();
            onNavButtonClick();
            await new Promise(resolve => setTimeout(resolve, (1000)));
            navigate(redirect);
        }
    };

    const toggleMenu = async () => {
        if (menu === 'not-visible') {
            setMenuAnimation('menu');
            setMenuAnimation('move-nav');
            setMenuAnimation2('fade-nav');
            await new Promise(resolve => setTimeout(resolve, (10)));
            setMenu('visible');
        } else {
            setMenuAnimation('move-away-nav');
            await new Promise(resolve => setTimeout(resolve, (100)));
            setMenuAnimation2('fade-away-nav');
            await new Promise(resolve => setTimeout(resolve, (100)));
            setMenu('not-visible');
        }
    }

    return (
        <div id="nav-container">
            <div id="nav" className="w-full flex items-center b-black">
                <div id="nav-logo-container" className="nav-side flex">
                    <img id="nav-logo" className="w-auto" src={logo} alt="logo" />
                </div>
                <div id="nav-buttons" className="h-full flex justify-center items-center">
                    {actual === 1 && <NavButton1 title="INICIO" />}
                    {actual !== 1 && <NavButton2 title="INICIO" redirect="/" onClick={handleButtonClick} />}
                    {actual === 2 && <NavButton1 title="PARTICULARES" />}
                    {actual !== 2 && <NavButton2 title="PARTICULARES" redirect="/particulares" onClick={handleButtonClick} />}
                    {actual === 3 && <NavButton1 title="FLOTAS" />}
                    {actual !== 3 && <NavButton2 title="FLOTAS" redirect="/flotas" onClick={handleButtonClick} />}
                    {actual === 4 && <NavButton1 title="NOSOTROS" />}
                    {actual !== 4 && <NavButton2 title="NOSOTROS" redirect="/nosotros" onClick={handleButtonClick} />}
                    {actual === 5 && <NavButton1 title="CONTACTO" />}
                    {actual !== 5 && <NavButton2 title="CONTACTO" redirect="/contacto" onClick={handleButtonClick} />}
                </div>
                <div id="nav-info" className="nav-side flex flex-col justify-center">
                    <p className="c-white text-sm poppins-200 text-nowrap m-0">Luzuriaga 757, Hurlingham</p>
                    <p className="c-white text-sm poppins-200 text-nowrap m-0">Cél: (011) 15-3357-3254</p>
                    <p className="c-white text-sm poppins-200 text-nowrap m-0">info@nrtallerintegral.com.ar</p>
                </div>
                <button id="nav-menu-button" className="h-full" onClick={toggleMenu}>
                    <svg className="h-3/4 text-neutral-100" stroke="none" viewBox="0 0 24 24">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                        <g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4ZM7 12C7 11.4477 7.44772 11 8 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H8C7.44772 13 7 12.5523 7 12ZM13 18C13 17.4477 13.4477 17 14 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H14C13.4477 19 13 18.5523 13 18Z" fill="#ffffff"/> </g>
                    </svg>
                </button>
            </div>
            <div id="nav-menu-container" className={`nav-menu-${menu} fade-nav-2 w-full flex`}>
                <button id="nav-menu-glass" className={`${menuAnimation2} h-screen w-full glass-600`} onClick={toggleMenu}></button>
                <div id="nav-menu-padding" className="h-1 w-1/3"></div>
                <div id="nav-menu" className={`${menuAnimation} h-screen overflow-hidden w-2/3 b-black flex flex-col px-4`}>
                    <div id="nav-menu-title" className="w-full flex items-center justify-between border-b-2 border-b-red-600">
                        <div className="josefin-600 text-red-600 mt-2 ms-1">MENÚ</div>
                        <button className="h-full" onClick={toggleMenu}>
                            <svg className="h-7 text-red-600" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                                <g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#dc2626"/> </g>
                            </svg>
                        </button>
                    </div>
                    {actual !== 1 && <button className="w-fit c-white josefin-500 transition duration-300 ease-in-out hover:josefin-500 hover:text-red-600 mt-4 ms-2" onClick={() => handleMenuButtonClick('/')}>INICIO</button>}
                    {actual === 1 && <div className="w-fit c-white josefin-600 cursor-default mt-4 ms-2">INICIO</div>}
                    {actual !== 2 && <button className="w-fit c-white josefin-500 transition duration-300 ease-in-out hover:josefin-500 hover:text-red-600 mt-2 ms-2" onClick={() => handleMenuButtonClick('/particulares')}>PARTICULARES</button>}
                    {actual === 2 && <div className="w-fit c-white josefin-600 cursor-default mt-2 ms-2">PARTICULARES</div>}
                    {actual !== 3 && <button className="w-fit c-white josefin-500 transition duration-300 ease-in-out hover:josefin-500 hover:text-red-600 mt-2 ms-2" onClick={() => handleMenuButtonClick('/flotas')}>FLOTAS</button>}
                    {actual === 3 && <div className="w-fit c-white josefin-600 cursor-default mt-2 ms-2">FLOTAS</div>}
                    {actual !== 4 && <button className="w-fit c-white josefin-500 transition duration-300 ease-in-out hover:josefin-500 hover:text-red-600 mt-2 ms-2" onClick={() => handleMenuButtonClick('/nosotros')}>NOSOTROS</button>}
                    {actual === 4 && <div className="w-fit c-white josefin-600 cursor-default mt-2 ms-2">NOSOTROS</div>}
                    {actual !== 5 && <button className="w-fit c-white josefin-500 transition duration-300 ease-in-out hover:josefin-500 hover:text-red-600 mt-2 ms-2" onClick={() => handleMenuButtonClick('/contacto')}>CONTACTO</button>}
                    {actual === 5 && <div className="w-fit c-white josefin-600 cursor-default mt-2 ms-2">CONTACTO</div>}
                </div>
            </div>
        </div>
    );
}

export default Nav;